import { useContext } from 'react';

import { isDefined } from '@hsp/utilities';

import { ActionsContext } from 'context/actions/actions.context';

export const useActions = () => {
  const context = useContext(ActionsContext);

  if (!isDefined(context)) {
    throw new Error('useFormActions must be used within a FormActionsProvider');
  }

  return context;
};
